import { MenuEntry } from '@pancakeswap-libs/uikit'

const config: MenuEntry[] = [
  {
    label: 'Home',
    icon: 'HomeIcon',
    calloutClass: 'menulink',
    href: 'https://www.spideybarter.com/',
  },
  {
    label: 'Trade',
    icon: 'TradeIcon',
    calloutClass: 'menulink',
    initialOpenState: true,
    items: [
      {
        label: 'Exchange',
        href: '/swap',
      },
      {
        label: 'Liquidity',
        href: '/pool',
      },
    ],
  },
  {
    label: 'Farms',
    icon: 'FarmIcon',
    calloutClass: 'menulink',
    href: 'https://app.spideybarter.com/farms',
  },
  {
    label: 'Pools',
    icon: 'PoolIcon',
    calloutClass: 'menulink',
    href: 'https://app.spideybarter.com/pools',
  },
  {
    label: 'NFT',
    icon: 'NftIcon',
    calloutClass: 'menulink',
    href: 'https://nft.spideybarter.com',
  },
]

export default config
